<script>
  import { z } from "zod"
  import { createForm } from "felte"
  import { validator } from "@felte/validator-zod"
  import { useProjects } from "../../hooks/useProjects.js"
  import { translate } from "../../i18n/i18next.js";
  import AutoOpenedDialogBase2 from "../dialog/AutoOpenedDialogBase2.svelte";
  import DialogTitle from "../dialog/DialogTitle.svelte";
  import DialogContent from "../dialog/DialogContent.svelte";
  import DialogBottomControls from "../dialog/DialogBottomControls.svelte";
  import DialogBottomControlButton from "../dialog/DialogBottomControlButton.svelte";
  import DialogSplitter from "../dialog/DialogSplitter.svelte";
  import DialogContentInput from "../dialog/DialogContentInput.svelte";
  import DialogContentSelect from "../dialog/DialogContentSelect.svelte";
  import { getAppContext } from "../../AppContext.js";

  export let onSubmit
  export let dialog
  export let onClose

  const appContext = getAppContext()

  const projects = useProjects()

  const schema = z.object({
    name: z.string()
      .min(1, translate("frontend:components.editProjectDialog.projectNameTooShortError"))
      .refine((val) => {
        try {
          return $projects.map(project => project.name).findIndex(name => name === val) === -1
        } catch (e) {
          console.log(e)
          return false
        }
      }, {message: translate("errors.projectNameAlreadyTakenError")}),
    description: z.union([
      z.string(),
      z.null(),
    ]),
    timezone: z.union([
      z.string(),
      z.undefined(),
      z.null()
    ]).transform(val => val ?? "Asia/Tokyo"),
    plan: z.literal("auto-mps")
      .refine(val => {
        try {
          if (val === "auto-mps") {
            const autoMpsState = $appContext.packages.autoMps ?? {enabled: false, allowed: false}
            return autoMpsState.enabled && autoMpsState.allowed
          }
          return true
        } catch (e) {
          console.log(e)
          return false
        }
      }, {message: "Auto MPS のプロジェクトはこのサーバでは有効ではありません。"})  // TODO: [i18n] translation for auto-mps
  })

  const {form, errors, reset, createSubmitHandler} = createForm({
    onSubmit,
    extend: validator({schema})
  })
  const submitHandler = createSubmitHandler()

  function handleClose() {
    reset()
    onClose()
  }
</script>

<AutoOpenedDialogBase2 bind:this={dialog}>
  <DialogTitle>
    <!-- TODO: [i18n] translation for auto-mps   -->
    Auto MPS のプロジェクトを作成する
  </DialogTitle>
  <DialogSplitter />
  <DialogContent>
    <form use:form>
      <DialogContentInput
        name="name"
        label={translate("generic.projectName")}
        error={$errors.name}
      />
      <DialogContentInput
        name="description"
        label={translate("generic.projectDescription")}
        error={$errors.description}
      />
      <!--  TODO: [i18n] translation for auto-mps    -->
      <DialogContentSelect
        name="plan"
        label={"利用するパッケージ"}
        error={$errors.plan}
      >
        <option value="auto-mps">Auto MPS</option>
      </DialogContentSelect>
    </form>
  </DialogContent>
  <DialogSplitter />
  <DialogBottomControls>
    <DialogBottomControlButton onClick={submitHandler}>
      {translate("generic.create")}
    </DialogBottomControlButton>
    <DialogBottomControlButton variant="secondary" onClick={handleClose}>
      {translate("generic.cancel")}
    </DialogBottomControlButton>
  </DialogBottomControls>
</AutoOpenedDialogBase2>

<style>
  form {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }
</style>
